import React, { useReducer, useCallback, useEffect, useState } from "react";
import Router from "./Router";
import { UserContext } from "./Context/user_context";
import styled from "styled-components";
import "./Style.css";
import { getApiClient } from "./server/get_api_client";
import { Toaster } from "react-hot-toast";
import Cookies from "js-cookie";

const reducer = (state, action) => {
  switch (action.type) {
    case "set-user":
      return { ...state, user: action.me };
    default:
      return state;
  }
};

function App() {
  const [state, dispatch] = useReducer(reducer, {
    user: null,
  });
  const { user } = state;

  const clearToken = () => {
    Cookies.remove("hippocratic_portal_token");
    Cookies.remove("hippocratic_portal_contactid");
    dispatch({ type: "set-user", me: null });
  };

  useEffect(() => {
    if (
      Cookies.get("hippocratic_portal_token") &&
      Cookies.get("hippocratic_portal_contactid")
    ) {
      const id = Cookies.get("hippocratic_portal_contactid").toString();
      getApiClient()
        .me(id)
        .then((response) => {
          dispatch({ type: "set-user", me: response.data });
        })
        .catch(() => {
          clearToken();
        });
    } else {
      clearToken();
    }
  }, []);

  const setUser = useCallback((me) => {
    dispatch({ type: "set-user", me: me });
  }, []);

  return (
    <>
      <UserContext.Provider value={{ user, setUser }}>
        <Toaster />
        <Router />
      </UserContext.Provider>
    </>
  );
}

const FixedDimmer = styled.div`
  display: ${(props) => (props.active ? "block" : "none")};
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background: rgba(135, 169, 191, 0.42);
  backdrop-filter: blur(2px);
`;

export default App;